import { createContext, type ReactNode } from "react";
import evEnums from "@/enums/index";

export const EnumsContext = createContext(evEnums);

export const EnumsProvider = ({ children }: { children: ReactNode }) => {
  return <EnumsContext.Provider value={evEnums}>{children}</EnumsContext.Provider>;
};
